import { useEffect, useMemo, useState } from 'react';

// mise à jour du draft lorsque le ticket est refetch (mutateTicket)
export const useSetAttachements = ({
  isDraftSet,
  draft,
  ticket,
  recipientType,
  ticketValidating = false,
  attachments = [],
  setAttachments,
  setInlineAttachments,
}) => {
  const [isAttachmentSet, setIsAttachmentSet] = useState(false);
  const [isAttachmentUpdateInProgress, setIsAttachmentUpdateInProgress] =
    useState(false);

  const attachmentsHaveChanged = useMemo(() => {
    if (!draft || !recipientType) return false;
    if (isAttachmentUpdateInProgress) return false;

    const draftAttachmentsLength = draft?.attachments?.length || 0;
    const stateAttachmentsLength = attachments?.length || 0;
    const hasLengthChanged = draftAttachmentsLength !== stateAttachmentsLength;

    // Vérification plus précise des attachements
    if (hasLengthChanged) return true;

    // Comparaison des IDs des attachements
    const draftAttachmentsIds = new Set(
      draft?.attachments?.map((att) => att._id) || []
    );
    const stateAttachmentsIds = new Set(
      attachments?.map((att) => att._id) || []
    );

    return ![...draftAttachmentsIds].every((id) => stateAttachmentsIds.has(id));
  }, [
    draft?.attachments,
    attachments,
    recipientType,
    isAttachmentUpdateInProgress,
  ]);

  useEffect(() => {
    if (ticketValidating) return;
    console.log('mise à jour');
    console.log('isDraftSet', isDraftSet);
    if (!isDraftSet) return;

    // Synchronisation des attachements au chargement initial ou si changement
    if (
      (!isAttachmentSet && draft?.attachments?.length > 0) ||
      attachmentsHaveChanged
    ) {
      if (!isAttachmentUpdateInProgress) {
        setAttachments([...(draft?.attachments ?? [])]);
        setInlineAttachments([
          ...(draft?.attachments?.filter((att) => !att.isAtt) ?? []),
        ]);
        setIsAttachmentSet(true);
      }
    }
  }, [
    recipientType,
    ticket,
    ticketValidating,
    attachmentsHaveChanged,
    isAttachmentUpdateInProgress,
    isDraftSet,
    draft?.attachments,
    isAttachmentSet,
  ]);

  useEffect(() => {
    if (ticketValidating) {
      setIsAttachmentSet(false);
    }
  }, [ticketValidating]);

  // Fonction pour gérer les mises à jour d'attachements
  const handleAttachmentUpdate = async (updateFn) => {
    setIsAttachmentUpdateInProgress(true);
    try {
      await updateFn();
    } finally {
      setIsAttachmentUpdateInProgress(false);
    }
  };

  return {
    isAttachmentSet,
    draft,
    handleAttachmentUpdate,
  };
};
